/*
 * Sign-in return-target validation shared by the sign-in page and its tests.
 */

"use strict";

const RETRO_SIGNIN_HOSTS=new Set(
	[
	'retro.kanoogi.com'
	]);

export function ResolveSigninDestination(value, currentOrigin)
	{
	if (typeof value!=='string' || value.length<1 || value.length>2048) return('/home');

	try
		{
		const origin=new URL(currentOrigin);
		const target=new URL(value,origin);
		if (target.username || target.password) return('/home');
		if (target.origin===origin.origin)
			return(`${target.pathname}${target.search}${target.hash}`);
		if (target.protocol==='https:' && !target.port && RETRO_SIGNIN_HOSTS.has(target.hostname))
			return(target.href);
		}
	catch (err) {}

	return('/home');
	}

export { RETRO_SIGNIN_HOSTS };
